module.exports = __webpack_public_path__ + "static/media/bikini-report.8929ff1e.jpg";